import { requester, storeRequester } from "App";
import { createSlice } from "@reduxjs/toolkit";
import { setLocalStorage } from "shared/utils/Utils";
import { Cookie, deleteCookie, setCookie } from "shared/StoreRequester";

export const AuthReducer = createSlice({
  name: "Auth",
  initialState: {
    token: null,
  },
  reducers: {
    setToken: (state, action) => {
      let token = action.payload;
      if (token) {
        setCookie(Cookie.JWT, token, 1);
      }
      return {
        ...state,
        token: token,
      };
    },
    reset(state) {
      deleteCookie(Cookie.JWT);
      return { ...state, token: null, data: null };
    },
  },
  extraReducers: {},
});
